import dayjs from 'dayjs';
import i18n from '@/i18n';

// A person's or workspace's name as the API accepts it: letters of any language, digits, spaces and
// . , - _ ' ’ & ( ) @ + (the API rejects anything else with 400).
const PLAIN_NAME_RE = /^[\p{L}\p{M}\p{N} .,\-_'’&()@+\u200C\u200D]+$/u;
// the longest person's name the API keeps
export const USERNAME_MAX_LENGTH = 150;
// the longest workspace name the API keeps
export const WORKSPACE_NAME_MAX_LENGTH = 72;
export const isValidName = (name, maxLength) => name.length <= maxLength && PLAIN_NAME_RE.test(name);

export const formatDayoffDateRange = (dates) => {
  if (!dates || !dates.length) return '';
  const sorted = [...dates].sort();
  const first = dayjs(sorted[0]);
  const last = dayjs(sorted[sorted.length - 1]);
  if (sorted.length === 1) return first.format('D MMM');
  // scattered days would produce a long unreadable list, so only the span and total are shown
  const isContinuous = last.diff(first, 'day') + 1 === sorted.length;
  const firstFormat = first.isSame(last, 'month') ? 'D' : 'D MMM';
  const range = `${first.format(firstFormat)}–${last.format('D MMM')}`;
  if (isContinuous) return range;
  return `${range} · ${i18n.global.t('dayoff.days_count', sorted.length)}`;
};

export const filterItems = (items, query, getText) => {
  const normalized = query.trim().toLowerCase();
  if (!normalized) return items;
  return items.filter(item => getText(item).toLowerCase().includes(normalized));
};

export const asyncFilter = (array, predicate) => {
  const data = Array.from(array);
  return Promise.all(data.map((element, index) => predicate(element, index, data)))
    .then(result => data.filter((element, index) => result[index]));
};

export const openDesktopApp = async (uri) => {
  let iframe = document.querySelector('#hiddenIframe');

  if (!iframe) {
    iframe = document.createElement('iframe');
    iframe.src = 'about:blank';
    iframe.id = 'hiddenIframe';
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
  }
  iframe.contentWindow.location.href = uri;
};

const getAppUrlQueryString = (action, args) => {
  if (action === 'set') {
    return Object.keys(args || {})
      .filter(key => args[key] !== undefined && args[key] !== null)
      .map(key => `${key}=${args[key]}`)
      .join('&');
  }

  const params = new URLSearchParams();
  Object.keys(args || {}).forEach((key) => {
    if (args[key] !== undefined && args[key] !== null) {
      params.set(key, args[key]);
    }
  });
  return params.toString();
};

export const generateAppUrl = (action, args) => {
  const minimalEnvAddon = process.env.VUE_APP_ENV !== 'live' ? `${process.env.VUE_APP_ENV}` : '';
  const queryString = getAppUrlQueryString(action, args);
  return `comtracklify${minimalEnvAddon}://${action}${queryString ? `?${queryString}` : ''}`;
};

export const userSearchText = (user, unassignLabel) => {
  if (!user || !user.id) return unassignLabel;
  return `${user.username || ''} ${user.email || ''}`;
};

export default {
  asyncFilter,
};
